import React from 'react';
import styled from 'styled-components';
import CalendarSection from '../comp/CalendarSection';
import ComparisonChartSection from '../comp/ComparisonChartSection';
import { cores, coresGrafico } from '../../../../styles/styleUtils';

const ChartsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; // Two equal columns
  gap: 30px;

  @media (max-width: 992px) {
    // Stack charts below 992px
    grid-template-columns: 1fr;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  color: ${cores.chumbo};
  margin: 0;
`;

const FilterButton = styled.button`
  background-color: ${cores.laranja};
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${cores.laranjaEscuro};
  }
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 25px;
`;

const handleFiltersClick = () => {
  console.log('Analysis Filters clicked');
  // Logic to open filter options
};

// Dummy Data for Horizontal Chart
const weeklyAnalysisData = {
  options: {
    chart: { id: 'weekly-analysis', toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '50%', // Adjust bar height
        borderRadius: 4,
        dataLabels: {
          position: 'top', // Show value outside the bar if space allows
        },
      },
    },
    colors: coresGrafico,
    dataLabels: {
      enabled: true,
      offsetX: 20, // Adjust label position
      style: {
        fontSize: '10px',
        colors: [cores.chumbo],
      },
      formatter: (val, opts) => {
        // Only show labels for the 'Realizado' series perhaps, or customize
        // if (opts.seriesIndex === 0) return val;
        return val;
      },
    },
    xaxis: {
      categories: ['Semana 4', 'Semana 3', 'Semana 2', 'Semana 1'], // Reversed order for horizontal
      max: 500, // Match image axis
      labels: { show: true },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '11px',
          fontWeight: 600,
        },
      },
    },
    grid: {
      xaxis: { lines: { show: true } }, // Show vertical grid lines
      yaxis: { lines: { show: false } }, // Hide horizontal grid lines
    },
    legend: { position: 'top', horizontalAlign: 'left' },
    tooltip: {
      y: { formatter: (val) => `${val}` }, // Simple tooltip value
    },
  },
  series: [
    { name: 'Realizado', data: [350, 280, 320, 250] }, // Data matching visual order bottom-to-top
    { name: 'Meta', data: [380, 410, 390, 300] }, // Data matching visual order bottom-to-top
  ],
};

const ChartsSection2 = ({ data, receivableDates, onDoubleClick }) => {
  return (
    <ChartsContainer>
      <div>
        <ComparisonChartSection data={data} />
      </div>
      <CalendarSection title={'Próximos Pagamentos'} receivableDates={receivableDates} onDoubleClick={onDoubleClick}/>
    </ChartsContainer>
  );
};

export default ChartsSection2;
